// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"2d4fbfa4","299":"da7890bf","453":"4a7e93a5","970":"dd1b0cdc"}[chunkId] + ".chunk.js";
};